class ProductGallery extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.initSlider()
  }

  initSlider() {
    const swiperEl = this.querySelector('.swiper')
    if (!swiperEl) {
      return
    }

    this.slider = new Swiper(swiperEl, {
      slidesPerView: 1.3,
      spaceBetween: 20,
      autoHeight: false,
      // centeredSlides: true,
      navigation: {
        nextEl: '.product-gallery .product-gallery__slide-button--next',
        prevEl: '.product-gallery .product-gallery__slide-button--prev',
      },
      pagination: {
        el: '.product-gallery .swiper-pagination',
        type: 'progressbar',
      },
    })
  }
}

if (!customElements.get('product-gallery')) {
  customElements.define('product-gallery', ProductGallery)
}